module.exports = "/media/scan_white.63266c18.png";